module.exports = __webpack_public_path__ + "assets/img/wxbook.13c819c2.svg";